export default "__VITE_ASSET__CKwcN6v2__"